import offside from 'offside-js';

let navbar = document.querySelector('.ch-single-nav-mobile');
let openButton = document.getElementById('open-button');
let toc = document.getElementById('toc');

if (navbar) {
	navbar.classList.add('active');

	let addEvent = function (object, type, callback) {
		if (object == null || typeof (object) == 'undefined') return;
		if (object.addEventListener) {
			object.addEventListener(type, callback, false);
		} else if (object.attachEvent) {
			object.attachEvent("on" + type, callback);
		} else {
			object["on" + type] = callback;
		}
	};

	let chNav = offside('#single-menu', {
		slidingElementsSelector: '#push-content, #my-button',
		buttonsSelector: '#my-button, #close-button',
		afterOpen: function () {

			if (toc) {
				let selectClass = document.getElementById('contents-select');


				if (selectClass) {
					selectClass.selectedIndex = 'first-option';

					selectClass.addEventListener('change', function () {
						setTimeout(function () {
							chNav.close();
						}, 500);
					});
				}
			}

		},
		afterClose: function () {

			if (toc) {
				let selectClass = document.getElementById('contents-select');

				setTimeout(function () {
					selectClass.selectedIndex = 'first-option';
				}, 500);
			}
		}
	});

	chNav.close();

	function doClose() {
		chNav.close();
	};

	function doOpen() {
		chNav.open();
	}

	function doToggle() {
		chNav.toggle();
		navIcon.classList.toggle('open');
		console.log('toggle');
		openButton.classList.toggle('active');
	}

	let navIcon = document.querySelector('.btn');

	navIcon.addEventListener("touchStart", onlyTouch, false);

	function onlyTouch(ev) {
		ev.preventDefault();
		doToggle();
	}

	navIcon.addEventListener("click", onlyClick, false);

	function onlyClick(ev) {
		ev.preventDefault();
		doToggle();
	}
}
